import { MutableRefObject, useEffect, useRef, useState } from "react";

type ReturnValue = {
  inputHeight: number;
  labelRef: MutableRefObject<HTMLLabelElement | null>;
  inputRef: MutableRefObject<HTMLInputElement | null>;
};

export const useDynamicInputHeight = (): ReturnValue => {
  const labelRef = useRef<HTMLLabelElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [inputHeight, setInputHeight] = useState<number>(0);

  useEffect(() => {
    const handleResize = () => {
      const labelElement = labelRef.current;
      const inputElement = inputRef.current;
      if (!labelElement || !inputElement) {
        return;
      }
      const inputHeight = inputElement.clientHeight;
      const labelHeight = labelElement.scrollHeight;

      setInputHeight(Math.max(inputHeight, labelHeight + 24));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { inputHeight, inputRef, labelRef };
};
